// src/common/components/Delay/Delay.tsx
import { useState, useEffect, ReactNode } from "react";

interface DelayProps {
  children: ReactNode;
  fallback: ReactNode;
  delay?: number;
}

export default function Delay({ children, fallback, delay = 300 }: DelayProps) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShow(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  return <>{show ? children : fallback}</>;
}
